import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ArrowRight, Menu, Phone, X } from "lucide-react";
import { CONTACT } from "../data/site";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Products" },
  { to: "/solutions", label: "Solutions" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const close = () => setOpen(false);
  return (
    <>
      <header className="site-header" data-testid="site-header">
        <div className="container">
          <Link to="/" className="logo-chip" data-testid="header-logo" onClick={close}>
            <img src="/assets/custoracks-logo.png" alt="CustoRacks — Customised Storage Solutions" />
          </Link>
          <nav className="main-nav" data-testid="main-nav">
            {NAV.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.to === "/"} className={({ isActive }) => (isActive ? "active" : "")} data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="header-cta">
            <a className="header-phone" href={CONTACT.phoneHref} data-testid="header-phone-link"><Phone size={15} /> {CONTACT.phoneDisplay}</a>
            <Link to="/contact" className="btn btn-orange header-quote" data-testid="header-quote-btn">Get a Quote <ArrowRight size={15} /></Link>
            <button className="menu-btn" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-testid="mobile-menu-btn">{open ? <X size={24} /> : <Menu size={24} />}</button>
          </div>
        </div>
      </header>
      <nav className={open ? "mobile-nav open" : "mobile-nav"} data-testid="mobile-nav" key={location.pathname}>
        {NAV.map((item) => (
          <Link key={item.to} to={item.to} onClick={close} data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>{item.label}</Link>
        ))}
        <Link to="/contact" className="btn btn-orange" onClick={close} data-testid="mobile-nav-quote">Get a Quote</Link>
      </nav>
    </>
  );
}
